import _ from "lodash";
import HelperArray from "utils/helper-array";
import ObjectBooking from "utils/objects/booking";
import { bookingStatus } from "utils/constants/booking-constants";
import FetchTimeslotCapacity from "utils/fetch/FetchTimeslotCapacity";
import store from "services/redux/store";
import { dataConstants } from "services/redux/data/constants";
import HelperDate, { dateFormat } from 'utils/helper-date'

export default class ObjectBookingInvitation {
	
	/**
	 *
	 * @param value
	 */
	static log = ( value ) => {
		console.prefix( 'ObjectBookingInvitation', value );
	}
	
	/**
	 *
	 * @param bookings
	 * @param validateDate
	 * @returns {string|*}
	 */
	static getDatesString = ( bookings, { validateDate = true } = {} ) => {
		const dates = [];
		
		_.forEach( bookings, booking => {
			if( !validateDate || HelperDate.date( booking.booking_date, dateFormat.DATE ).isSameOrAfter( HelperDate.date() ) ) {
				if ( !_.includes( dates, booking.booking_date ) ) {
					dates.push( booking.booking_date );
				}
			}
		});
		
		
		return this.datesPretty( dates );
	}
	
	/**
	 *
	 * @param dates
	 * @returns {string|*}
	 */
	static datesPretty = ( dates ) => {
		dates = _.orderBy( dates );
		
		if( _.size( dates ) > 0 ) {
			const datesGrouped = {};
			
			_.forEach( dates, date => {
				const dateObject = HelperDate.date( date );
				
				const year = dateObject.format('Y');
				const month = dateObject.format('MMMM');
				const day = dateObject.format('D');
				
				if( !_.has( datesGrouped, year ) ) {
					datesGrouped[ year ] = {}
				}
				
				if( !_.has( datesGrouped[ year ], month ) ) {
					datesGrouped[ year ][ month ] = [];
				}
				
				if( !_.includes( datesGrouped[ year ][ month ], day ) ) {
					datesGrouped[ year ][ month ].push( day );
				}
			});
			
			const yearsArray = [];
			_.forEach( datesGrouped, ( months, year ) => {
				const monthsArray = [];
				
				_.forEach( months, ( days, month ) => {
					monthsArray.push( HelperArray.naturalJoin( days ) +' '+ month )
				});
				
				yearsArray.push( HelperArray.naturalJoin( monthsArray ) +' '+ year )
			})
			
			return HelperArray.naturalJoin( yearsArray );
		}
		
		return HelperArray.naturalJoin(
			_.map( dates, date => {
				return HelperDate.date(date).format(dateFormat.DATE_PRETTY);
			})
		);
	}
	
	/**
	 *
	 * @param _bookings
	 * @returns {unknown[]}
	 */
	static getBookingsInvited = ( _bookings ) => {
		// Only get the invited bookings
		const bookingsInvited = ObjectBooking.filterByStatus( _bookings, [ bookingStatus.INVITED ] );
		const invites = {};
		
		_.forEach( bookingsInvited, booking => {
			const bookingInvitation = _.get( booking, 'booking_invitation', {} );
			
			if( HelperDate.date( booking.booking_date, dateFormat.DATE ).isSameOrAfter( HelperDate.date() ) ) {
				if( !_.has( invites, invites[ bookingInvitation.guid ] ) ) {
					invites[ bookingInvitation.guid ] = {
						...bookingInvitation,
						dates: [],
					};
				}
				
				invites[ bookingInvitation.guid ].dates.push( booking.booking_date );
			}
		});
		
		return _.orderBy( invites, 'created_at', 'desc' );
		//return _.orderBy( invites, 'dates' );
	}
	
	/**
	 *
	 * @param invitation
	 * @param onlyMyBookings
	 * @param inviteesHidden
	 * @returns {{bookingsByDate: {}, employees: {}}}
	 */
	static parse = ( invitation, { onlyMyBookings = true, inviteesHidden = false } = {} ) => {
		const _employee = store.getState().data[ dataConstants.EMPLOYEE ];
		const employees = {};
		const bookingsByDate = {};
		const organizer = _.get( invitation, 'employee', {} );
		
		const bookings = [];
		_.forEach( invitation.bookings, booking => {
			if( _.get( booking, ['employee', 'guid'], null ) !== null ) {
				bookings.push( booking )
			}
		});
		
		// Go through the bookings
		_.forEach( bookings, booking => {
			const bookingEmployeeGuid = _.get( booking, ['employee', 'guid'], null );
			if( bookingEmployeeGuid !== null ) {
				
				// Must show?
				if( !inviteesHidden || (!_.isEmpty( organizer ) && bookingEmployeeGuid === organizer.guid) || bookingEmployeeGuid === _employee.guid ) {
				
					// Add the employee to the list
					if ( !_.has( employees, bookingEmployeeGuid ) ) {
						employees[ bookingEmployeeGuid ] = booking.employee;
					}
					
					// Add the date to the list
					if ( !_.has( bookingsByDate, booking.booking_date ) ) {
						bookingsByDate[ booking.booking_date ] = {
							title: _.capitalize( HelperDate.date( booking.booking_date, dateFormat.DATE ).format( dateFormat.DATE_PRETTY ) ),
							booking: {},
							data: {}
						};
					}
					
					const bookingKey = FetchTimeslotCapacity.keyByBooking( booking );
					if( !_.has( bookingsByDate[ booking.booking_date ].booking, bookingKey ) ) {
						if( bookingEmployeeGuid === _employee.guid ) {
							bookingsByDate[ booking.booking_date ].booking[ bookingKey ] = booking;
						}
					}
					
					if( !_.has( bookingsByDate[ booking.booking_date ].data, bookingKey ) ) {
						bookingsByDate[ booking.booking_date ].data[ bookingKey ] = {
							[ bookingStatus.INVITED ]: [],
							[ bookingStatus.INVITE_ACCEPTED ]: [],
							[ bookingStatus.INVITE_REJECTED ]: []
						};
					}
					
					let status = booking.status;
					switch( booking.status ) {
						case bookingStatus.ACTIVE:
							status = bookingStatus.INVITE_ACCEPTED
							break;
						
						case bookingStatus.CANCELLED:
							status = bookingStatus.INVITE_REJECTED
							break;
					}
					
					bookingsByDate[ booking.booking_date ].data[ bookingKey ][ status ].push( { employee_guid: bookingEmployeeGuid, booking_guid: booking.guid } )
				}
			}
		});
		
		// Example: when I'm the booker but I do not have a booking for it: then show it by somebody else
		if( !onlyMyBookings ) {
			// Try to check again
			_.forEach( bookings, booking => {
				const bookingKey = FetchTimeslotCapacity.keyByBooking( booking );
				
				if( !_.has( bookingsByDate[ booking.booking_date ].booking, bookingKey ) ) {
					bookingsByDate[ booking.booking_date ].booking[ bookingKey ] = booking;
				}
			});
		}
		
		return {
			employees,
			bookingsByDate
		}
	}
}
